const bigFacilities = [
  {
    title: "HYROX & Functional Training",
    desc: "Kompletny obiekt HYROX z profesjonalnym sprzętem do treningu funkcjonalnego, assault bikes, wioślarzami i strefą cardio",
    items: ["Oficjalny partner HYROX", "Sprzęt premium", "Strefa funkcjonalna"],
    image: "https://api.playitas.net/sites/default/files/styles/one_third_hight/public/2025-04/HYROX_01.JPG?h=10d202d3&itok=LujzvEX1",
    color: "text-orange-500",
  },
  {
    title: "Basen Olimpijski 50m",
    desc: "Podgrzewany basen olimpijski z 8 torami, temperatura wody 25-26°C przez cały rok",
    items: ["50 metrów, 8 torów", "Podgrzewany cały rok"],
    image: "https://api.playitas.net/sites/default/files/styles/one_third_hight/public/2024-02/Olympic_Pool.jpg?h=c74750f6&itok=c0HSrgWy",
    color: "text-teal-500",
  },
  {
    title: "Centrum Rowerowe",
    desc: "Ponad 250 rowerów premium i setki kilometrów tras treningowych po całej wyspie",
    items: ["250+ rowerów premium", "Serwis techniczny"],
    image: "https://api.playitas.net/sites/default/files/styles/one_third_hight/public/2019-08/header_1.jpg?h=d1cb525d&itok=yjlGDat4",
    color: "text-yellow-400",
  },
];

const smallFacilities = [
  { icon: "ri-basketball-line", title: "Korty Tenisowe", desc: "12 kortów profesjonalnych", color: "bg-orange-100 text-orange-500" },
  { icon: "ri-run-line", title: "Biegnia 400m", desc: "Profesjonalna biegnia lekkoatletyczna", color: "bg-teal-100 text-teal-500" },
  { icon: "ri-dumbbell-line", title: "Siłownia", desc: "Nowoczesny sprzęt fitness", color: "bg-orange-100 text-orange-500" },
  { icon: "ri-heart-pulse-line", title: "SPA & Fizjoterapia", desc: "Regeneracja i masaże", color: "bg-teal-100 text-teal-500" },
];

export default function PlayitasFacilities() {
  return (
    <section id="facilities" className="py-32 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-gray-500 text-sm tracking-widest mb-4">NASZE OBIEKTY</p>
          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            <span className="font-normal">Infrastruktura stworzona dla</span><br />
            <span className="font-bold italic">profesjonalistów</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-6">
          {bigFacilities.map((f) => (
            <div key={f.title} className="group relative h-[600px] rounded-3xl overflow-hidden cursor-pointer">
              <img src={f.image} alt={f.title}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <h3 className="text-3xl font-bold mb-4">{f.title}</h3>
                <p className="text-lg leading-relaxed mb-4 opacity-90">{f.desc}</p>
                <ul className="space-y-2">
                  {f.items.map(item => (
                    <li key={item} className="flex items-center gap-2">
                      <i className={`ri-check-line ${f.color}`} />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-4 gap-6 mb-12">
          {smallFacilities.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-2xl p-6 text-center hover:shadow-lg transition-shadow">
              <div className={`w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4 ${f.color}`}
                style={{ backgroundColor: f.color.includes("orange") ? "#FFF7ED" : "#F0FDF4" }}>
                <i className={`${f.icon} text-3xl`} />
              </div>
              <h4 className="font-bold text-lg mb-2">{f.title}</h4>
              <p className="text-gray-600 text-sm">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-orange-50 to-teal-50 rounded-3xl p-12 text-center">
          <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full mx-auto mb-6 shadow-lg">
            <i className="ri-information-line text-4xl text-orange-500" />
          </div>
          <h3 className="text-3xl font-bold text-gray-900 mb-4">Chcesz poznać więcej szczegółów?</h3>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto">
            Odwiedź oficjalną stronę Playitas Resort lub pobierz nasz szczegółowy katalog.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="https://www.playitas.net" target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-full font-bold text-lg transition-all cursor-pointer whitespace-nowrap shadow-lg">
              <i className="ri-external-link-line text-xl" /> ODWIEDŹ STRONĘ PLAYITAS
            </a>
            <a href="https://drive.google.com/uc?export=download&id=10blc-uteXfCiM-_9hj-PYgcbCI34jQ9k" target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white hover:bg-gray-50 text-gray-900 px-8 py-4 rounded-full font-bold text-lg transition-all cursor-pointer whitespace-nowrap shadow-lg border-2 border-gray-200">
              <i className="ri-download-cloud-line text-xl" /> POBIERZ KATALOG PDF
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
